<template>
  <div class="container">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="isShowIndex"></HeaderRegion>
    <div style="width: 100%;" v-if="id==8 || id==9">
      <div style="margin-top: 80px;display: flex;justify-content: center;align-items: center;height: 80px;">
         <el-button round :class="isTrue?'true':'false'" @click="click1">领取任务流程</el-button>
         <el-button round :class="isTrue2?'true':'false'" @click="click2">自主投稿流程</el-button>
      </div>
    </div>

    <div v-html="showContent" class="rich-txt-box">

    </div>


    <!-- 底部展示区域 -->
    <!--    <BottomRegion ref="bottomForm"></BottomRegion>-->
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import {baseImgUrl} from "../../api/config"

export default {
  name: "home",
  components: {
    HeaderRegion,
    BottomRegion,
  },
  data() {
    return {
      headerForm: 0,
      isShowIndex: 0,
      //indexBanner,justDetail
      pageType: "",
      id: "",
      showContent: "",
      isTrue:true,
      isTrue2:false
    };
  },
  watch: {
    $route: function (to, from) {
      console.log(to)
      this.id = to.query.id;
      this.pageType = to.query.pageType;
      this.getData();
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.pageType = this.$route.query.pageType;
    this.getData();
  },
  methods: {
    click1(){
      this.id =9
      this.isTrue = true
      this.isTrue2 = false
      this.getData();
    },
    click2(){
      this.id = 8
      this.isTrue = false
      this.isTrue2 = true
      this.getData();
    },
    async getData() {
      if (this.pageType == 'indexBanner'){
        this.isShowIndex = -1;
      }else{
        if (this.id == 1) {
          // '隐私协议'
          this.isShowIndex = 6;
        } else if (this.id == 2) {
          // '平台介绍'
          this.isShowIndex = 3;
        } else if (this.id ==8 || this.id ==9) {
          // '工作流程'
          this.isShowIndex = 4;
        } else if (this.id == 4) {
          // '设计师权益'
          this.isShowIndex = 5;
        } else if (this.id == 5) {
          // '我要反馈'
        } else if (this.id == 6) {
          //'廉政投诉举报'
        } else if (this.id == 7) {
          //'积分规则'
        }
      }

      try {
        let newApi;

        if (this.pageType == 'indexBanner') {
          //从banner跳转过来的
          let data = {
            id: this.id
          }
          newApi = await this.$http.bannerDetails(data);
        } else {
          let data = {
            queryType: this.id
          }
          newApi = await this.$http.goAgreement(data);
        }
        const res = newApi
        if (res.code == 200) {
          let mycontent;
          if (this.pageType == 'indexBanner') {
            if (res.result) {
              mycontent = res.result.articleContent;
            }
          } else {
            if (res.result.length && res.result.length > 0) {
              mycontent = res.result[0].articleContent;
            }
          }
          mycontent = mycontent.replace(/\<img/gi, '<img class="rich-img"');
          this.showContent = mycontent;
        } else {
          // this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
  .el-button{
    background-color: #b7919e;
  }
  .true{
    background-color: #b7919e !important;
    color: #FFFFFF !important;
    outline: none;
    margin-right: 50px;
  }
  .false{
    background-color: #95848a;
    color: #FFFFFF;
    outline: none;
     margin-right: 50px;
  }
.rich-txt-box {
  padding: 80px 20px 20px 20px;
  box-sizing: boder-box;
  background-color: white;
  width: 1186px;
  margin: 0 auto;
}

.rich-txt-box /deep/ .rich-img {
  width: 100%;
  height: auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/home/richText.vue